export const SET_HYBRID_PENDING = 'SET_HYBRID_PENDING';
export const CLEAR_HYBRID_PENDING = 'CLEAR_HYBRID_PENDING';
export const SET_HYBRID_ERROR = 'SET_HYBRID_ERROR';
export const CLEAR_HYBRID_ERROR = 'CLEAR_HYBRID_ERROR';
export const RESET_HYBRID = 'RESET_HYBRID';